/**
 * Downloads a file from a given URL
 * @param url - The URL of the file to download
 * @param customFileName - Custom filename for the download
 * @returns Promise that resolves when the download is complete
 */
export const downloadFile = async (url: string, customFileName: string): Promise<void> => {
  const response = await fetch(url);
  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = customFileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
};
